import { getApiUrl, getAxiosInstanceByLoginMode, DEFAULT_PAGEABLE } from './shared';
import { constructPageString } from '../../utils/api-util';
import { isStringNumber, serializeAsQueryString } from '../../utils/utils';

const ARCHIVED_RENEWALS_BASE_URL = `${getApiUrl()}/renewal-archives`;

const DEFAULT_SEARCH = {
  classification: null,
  customerName: null,
  customerNumber: null,
  customerApproveDateAfter: null,
  archivedRenewalIds: null,
  branchIds: null
};

const search = (pageable = DEFAULT_PAGEABLE, criteria = DEFAULT_SEARCH) => {
  const pageString = constructPageString(pageable);
  const queryString = buildQueryString(criteria);
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}?${
      !!pageString ? pageString : ''
    }&${queryString}`
  );
};

const count = (criteria) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/count?${buildQueryString(criteria)}`
  );
};

const contract = (renewalId, agreementType) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/${renewalId}/contract/${agreementType}`,
    {
      responseType: 'arraybuffer'
    }
  );
};

const contractsInfo = (renewalId) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/${renewalId}/contracts-info`
  );
};

const getMarketCenterReport = (branchIds) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/renewal-report?${serializeAsQueryString({
      branchIds
    })}`
  );
};

const getReport = (branchIds, startDate, endDate) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/branches-report?${buildReportQueryString(
      branchIds,
      startDate,
      endDate
    )}`
  );
};

const getNoDeviationReport = (branchIds, startDate, endDate) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/branches-no-deviation-report?${buildReportQueryString(
      branchIds,
      startDate,
      endDate
    )}`
  );
};

const getZipCompletedReport = (branchIds, startDate, endDate) => {
  return getAxiosInstanceByLoginMode().get(
    `${ARCHIVED_RENEWALS_BASE_URL}/renewal-contracts-report?${buildReportQueryString(
      branchIds,
      startDate,
      endDate
    )}`, 
    {
      responseType: 'arraybuffer'
    }
  );
};

const buildReportQueryString = (branchIds, startDate, endDate) => {
  return serializeAsQueryString({ branchIds, startDate, endDate });
};

function buildQueryString(criteria) {
  const key = isStringNumber(criteria.search)
    ? 'customerNumber'
    : 'customerName';
  return serializeAsQueryString(
    {
      ...criteria,
      search: undefined, // delete this one
      [key]: criteria.search
    },
    true
  );
}

export {
  search,
  count,
  contract,
  getMarketCenterReport,
  getReport,
  contractsInfo,
  getZipCompletedReport, 
  getNoDeviationReport
};
